module.exports = __webpack_public_path__ + "public/viewMessage/shield.svg?eeaaf768";